import type { ReactNode } from "react";

type CollapsibleContentProps = {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
};

export function CollapsibleContent({
  isOpen,
  children,
  className,
}: CollapsibleContentProps) {
  return (
    <div
      className={`grid min-h-0 transition-[grid-template-rows] duration-300 ease-in-out ${
        isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
      } ${className ?? ""}`}
    >
      <div
        className={`overflow-hidden transition-opacity duration-300 ease-in-out ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        aria-hidden={!isOpen}
      >
        {children}
      </div>
    </div>
  );
}
